import * as XLSX from "xlsx";
const downloadDataIExcelSheet = (data: any, fileName: string) => {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Generate Excel file and trigger download
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default downloadDataIExcelSheet;
